import { connect } from "react-redux";
import get from "lodash/get";
import { getOrganizationInfo, getSignatories } from "../../../../store/selectors/appConfig";
import { SignatoryEmploymentDetailsComponent } from "./SignatoryEmploymentDetails";

const mapStateToProps = (state, { index }) => ({
  companyName: getOrganizationInfo(state).companyName,
  signatoryDocs: get(getSignatories(state)[index], "stakeholdersDocuments.documents", [])
});

export const SignatoryEmploymentDetails = connect(mapStateToProps)(
  SignatoryEmploymentDetailsComponent
);
